export default "__VITE_ASSET__BkRNuSBl__"